import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { PaymentReceivedService } from '../service/payment-received.service';
import { ToastMessageService } from '../toast-message.service';
import { DecimalValidator } from '../validator/decimal-validator';
import { NumberValidator } from '../validator/number-validator';
import { CurrencyService } from '../service/currency.service';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-edit-payment-received',
  templateUrl: './edit-payment-received.component.html',
  styleUrls: ['./edit-payment-received.component.css']
})
export class EditPaymentReceivedComponent implements OnInit {

  paymentForm!: FormGroup;
  submitFail = false;
  invalidAmount = false;
  @Output() newPaymentReceived = new EventEmitter<any>();
  public FINANCE = "financial_encoder";
  public isFinancialEncoder = this.userService.hasRole(this.FINANCE);

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    public bookingService: BookingService,
    private toastService: ToastMessageService,
    public paymentReceivedService: PaymentReceivedService,
    public currencyService: CurrencyService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    let payment = this.paymentReceivedService.selectedPayemnt;
    this.paymentForm = this.builder.group({
      amount: [payment.amount.toFixed(2), Validators.compose([DecimalValidator, NumberValidator])],
      currency: payment.currency,
      date: [moment(payment.date).toDate(), Validators.required],
      paymentType: [payment.paymentType, Validators.required],
      comment: payment.comment,
      invoiceNumber: payment.invoiceNumber,
      isFinancialRecord: payment.isFinancialRecord
    });
  }

  submit(){
    this.submitFail = false;
    if(this.paymentForm.invalid){
      this.toastService.addError("Error", "Form is not complated correctly.");
      this.submitFail = true;
      return;
    }
    let payment = this.paymentReceivedService.duplicatePayment(this.paymentReceivedService.selectedPayemnt);
    payment.amount = this.paymentForm.value.amount;
    payment.date = moment(this.paymentForm.value.date).utc(true);
    payment.invoiceNumber = this.paymentForm.value.invoiceNumber;
    payment.currency = this.paymentForm.value.currency;
    payment.comment = this.paymentForm.value.comment;
    payment.paymentType = this.paymentForm.value.paymentType;
    let isFinancialRecord = this.paymentForm.value.isFinancialRecord;
    this.httpService.putPaymentReceived(payment, isFinancialRecord, this.bookingService.booking.id!).subscribe(() => {
      this.paymentReceivedService.selectedPayemnt = payment;
      this.toastService.addSuccess("Success", "payment successfully updated.");
      this.newPaymentReceived.emit(null);
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }
  
  amountChange(event: any){
    let value = event.target.value as string;
    if(value.includes(",")){
      value = value.replaceAll(",", ".");
      event.target.value = value;
    }
  }

}
